import {removeRepresentativeCommission} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../../../representative-keys";

export function removeRepresentativeCommissionMutationOptions(representativeId: string) {
  return mutationOptions({
    mutationFn: (commissionId: number) =>
      removeRepresentativeCommission(representativeId, commissionId),
    mutationKey: representativeMutationKeys.removeRepresentativeCommission,
    onSuccess: async (_result, _commissionId, _context, {client}) => {
      await client.invalidateQueries({queryKey: representativeKeys.detail(representativeId)});
    },
  });
}
